import * as vueMounter from "@scripts/vueMounter.ts";
import { commonComponents } from "@scripts/public/common.ts";
import CourseSelectBtn from "@components/partials/public/projects/CourseSelectBtn.vue";
import InvestmentOptionSelectBtn from "@components/partials/public/projects/InvestmentOptionSelectBtn.vue";
import InvestmentOptionWithPanelSelectBtn from "@components/partials/public/projects/InvestmentOptionWithPanelSelectBtn.vue";
import ApplyWaitingListBtn from "@components/partials/public/projects/ApplyWaitingListBtn.vue";
import ApplyWaitingListByInvestmentOptionBtn from "@components/partials/public/projects/ApplyWaitingListByInvestmentOptionBtn.vue";
import WatchlistBtn from "@components/partials/public/projects/WatchlistBtn.vue";

const pageComponents = {
  CourseSelectBtn,
  InvestmentOptionSelectBtn,
  InvestmentOptionWithPanelSelectBtn,
  ApplyWaitingListBtn,
  ApplyWaitingListByInvestmentOptionBtn,
  WatchlistBtn
};

const components = Object.assign(pageComponents, commonComponents);

vueMounter.mount(components);

import { smoothScroll } from "@scripts/public/utility/smoothScroll.ts";
smoothScroll();

import { notActivatedModal } from "@scripts/public/utility/notActivatedModal.ts";
notActivatedModal();

import { notLoggedInModal } from "@scripts/public/utility/notLoggedInModal.ts";
notLoggedInModal();
